/* Bamboosa – vaste 'In winkelwagen'-balk (Essential Cart Drawer) 07-10
   Probleem: de app zet standaard de eerste maat klaar (bijv. 35-38), terwijl de
   productpagina zelf nog geen maat gekozen heeft ('Kies eerst je maat').
   Oplossing (alleen theme-kant, app ongewijzigd):
   1. Zolang op de pagina geen maat gekozen is, toont de balk 'Kies maat'.
   2. Klik op 'In winkelwagen' in de balk zonder maat -> niet toevoegen, naar de
      maatkeuze scrollen en de melding 'Kies eerst je maat.' tonen.
   Maatkeuze in de balk zelf blijft werken: de app zet die keuze door naar de pagina.
   Bij meerdere maatgroepen (Starterbundel) moet elke groep gekozen zijn; de app werkt
   de balk pas bij als de volledige variant bekend is. */
(function () {
  if (window.__bbStickyMaat) return;
  window.__bbStickyMaat = true;

  var PORTAL = '#sticky-cart-portal';
  // 19-10-2026: Duitse teksten op /de (html lang="de").
  var BB_DE = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('de') === 0;
  var T = BB_DE
    ? { kies: 'Größe wählen', eenMaat: 'Bitte wähle zuerst deine Größe.', meerMaten: 'Bitte wähle zuerst deine Größen.' }
    : { kies: 'Kies maat', eenMaat: 'Kies eerst je maat.', meerMaten: 'Kies eerst je maten.' };
  var lastStickyPick = 0; // tijdstip van een maatkeuze in de balk zelf

  function sizeGroups() {
    return document.querySelectorAll('form[data-product-form] [data-size-group]');
  }
  // Eerste maatgroep zonder keuze (bijv. Starterbundel: boxermaat en schoenmaat), of null.
  function firstOpenGroup() {
    var groups = sizeGroups();
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].querySelector('input[type="radio"]') && !groups[i].querySelector('input[type="radio"]:checked')) return groups[i];
    }
    return null;
  }
  function sizeChosen() {
    return !firstOpenGroup(); // geen maatgroepen of alle groepen gekozen
  }

  function syncPlaceholder() {
    var portal = document.querySelector(PORTAL);
    if (!portal) return;
    var chosen = sizeChosen();
    // Net een maat in de balk gekozen: de app zet de pagina bij; niet terugdraaien.
    if (!chosen && Date.now() - lastStickyPick < 2000) return;
    portal.querySelectorAll('select').forEach(function (sel) {
      // CSS (bamboosa-fixes-0710.css 9c) toont de select pas met dit kenmerk.
      if (!sel.hasAttribute('data-bb-sync')) sel.setAttribute('data-bb-sync', '');
      var ph = sel.querySelector('option[data-bb-placeholder]');
      if (chosen) {
        if (ph) {
          var wasSelected = ph.selected;
          ph.remove();
          if (wasSelected) {
            var form = sel.closest('[data-essential-cart-element="essential-sticky-cart-container"]');
            var idInput = form && form.querySelector('input[name="id"]');
            if (idInput && idInput.value) sel.value = idInput.value;
          }
        }
        return;
      }
      if (!ph) {
        ph = document.createElement('option');
        ph.value = '';
        ph.textContent = T.kies;
        ph.disabled = true;
        ph.setAttribute('data-bb-placeholder', '');
        sel.insertBefore(ph, sel.firstChild);
      }
      if (!ph.selected) ph.selected = true;
    });
  }

  // 07-10-2026 ronde 2: korte melding in beeld, zodat duidelijk is waarom er niets
  // wordt toegevoegd (de foutmelding bij de maatkeuze zelf kan buiten beeld vallen).
  var meldingTimer;
  function toonMelding(tekst) {
    var el = document.querySelector('.bb-sticky-melding');
    if (!el) {
      el = document.createElement('div');
      el.className = 'bb-sticky-melding';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = tekst;
    void el.offsetWidth;
    el.classList.add('is-zichtbaar');
    clearTimeout(meldingTimer);
    meldingTimer = setTimeout(function () { el.classList.remove('is-zichtbaar'); }, 3000);
  }

  function showSizeError() {
    var group = firstOpenGroup();
    if (!group) return;
    var err = group.querySelector('[data-size-error]');
    if (err) err.classList.remove('d-none');
    var aantal = sizeGroups().length;
    toonMelding(aantal > 1 ? T.meerMaten : T.eenMaat);
    group.scrollIntoView({ behavior: 'auto', block: 'center' });
  }

  // Klik op de knop in de balk zonder gekozen maat: tegenhouden.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest(PORTAL + ' [data-essential-cart-element="add-to-cart-button"]');
    if (!btn || sizeChosen()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showSizeError();
  }, true);

  // Maat gekozen op de pagina (of via de balk, die de pagina bijwerkt).
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-size-group] input[type="radio"]')) {
      var grp = e.target.closest('[data-size-group]');
      var err = grp && grp.querySelector('[data-size-error]');
      if (err) err.classList.add('d-none');
      setTimeout(syncPlaceholder, 0);
    } else if (e.target && e.target.closest && e.target.closest(PORTAL + ' select')) {
      // Maat gekozen in de balk: de app zet de pagina bij, daarna placeholder weg.
      lastStickyPick = Date.now();
      setTimeout(syncPlaceholder, 300);
    }
  }, true);

  // De app rendert de balk zelf (en opnieuw); daarom observeren.
  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; syncPlaceholder(); }, 30);
  });
  function start() {
    syncPlaceholder();
    mo.observe(document.body, { childList: true, subtree: true });
    // De app zet de waarde soms zelf terug op de eerste maat zonder DOM-wijziging;
    // daarom ook een lichte periodieke controle (doet niets zodra een maat gekozen is).
    setInterval(syncPlaceholder, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
